import React from "react";

const FailedIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15.981"
      viewBox="0 0 16 15.981"
    >
      <path
        id="fld_ic"
        d="M26.974,12.975a8,8,0,0,0-5.66,13.66,8.084,8.084,0,0,0,5.66,2.321,8.213,8.213,0,0,0,5.66-2.321,8,8,0,0,0-5.66-13.66ZM23.927,17.2a.781.781,0,0,1,.507.217l2.539,2.539,2.539-2.539a.7.7,0,0,1,1.016,0,.7.7,0,0,1,0,1.016L27.99,20.974l2.539,2.539a.718.718,0,1,1-1.016,1.016L26.974,21.99,24.435,24.6a.718.718,0,0,1-1.016-1.016l2.539-2.539-2.539-2.612a.7.7,0,0,1,0-1.016A.784.784,0,0,1,23.927,17.2Z"
        transform="translate(-18.974 -12.975)"
        fill={fill ? fill : "#e51717"}
      />
    </svg>
  );
};

export default FailedIcon;
